import React, { createContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { Head } from 'modules/components';
import { Box, constants, GlobalFontFace, ThemeProvider } from '@match/react-component-library';
import { Categories, GlobalCssReset, Router } from 'modules/components';
import { useSiteData } from 'modules/hooks';
import { initialSiteData } from 'modules/hooks/useSiteData';
import styled, { getThemeForSite } from 'packages/theming';

const { SEMANTIC_COLOR_NAME } = constants;

export const SiteDataContext = createContext(initialSiteData);
const SiteDataProvider = SiteDataContext.Provider;

const App: React.FunctionComponent = () => {
  const siteData = useSiteData();

  const myLocale = siteData.cultureCode;
  const messages = require(`i18n/${siteData.cultureCode}-messages`) || {};
  const theme = getThemeForSite(siteData.siteCode, siteData.urlCode);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <IntlProvider locale={myLocale} messages={messages}>
        <SiteDataProvider value={siteData}>
          <ThemeProvider theme={theme}>
            {siteData.siteDataLoaded ? (
              <React.Fragment>
                <Head />
                <GlobalCssReset margins padding borderBox lists images anchors />
                <GlobalFontFace />
                <Categories>
                  <Router />
                </Categories>
              </React.Fragment>
            ) : (
              <PlaceholderHeader
                width="100%"
                height={56}
                backgroundColor={SEMANTIC_COLOR_NAME.TEXT_PRIMARY}
              />
            )}
          </ThemeProvider>
        </SiteDataProvider>
      </IntlProvider>
    </BrowserRouter>
  );
};

const PlaceholderHeader = styled(Box)({
  clear: 'both',
});

export default App;
